// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

const BASE_ROUTE = 'invoice-root'

export const ROUTE_NAMES = {
  LIST: 'invoice-list',
  DETAILS: 'invoice-details',
  UPLOAD: 'invoice-upload'
}

const ROUTES = {
  [BASE_ROUTE]: {
    name: BASE_ROUTE,
    path: 'invoice'
  },
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'list'
  },
  [ROUTE_NAMES.UPLOAD]: {
    name: ROUTE_NAMES.UPLOAD,
    path: 'upload'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: ':id'
  }
}

export default [
  {
    name: ROUTES[BASE_ROUTE].name,
    path: ROUTES[BASE_ROUTE].path,
    component: {
      template: '<router-view></router-view>',
      name: 'InvoiceModule'
    },
    children: [
      {
        name: ROUTES[ROUTE_NAMES.LIST].name,
        path: ROUTES[ROUTE_NAMES.LIST].path,
        component: (resolve) => require(['./views/list'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.UPLOAD].name,
        path: ROUTES[ROUTE_NAMES.UPLOAD].path,
        component: (resolve) => require(['./views/upload'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.DETAILS].name,
        path: ROUTES[ROUTE_NAMES.DETAILS].path,
        component: (resolve) => require(['./views/details'], resolve),
        props: true
      }
    ]
  }
]
